import * as React from 'react';
import SettingsContainer from '../Settings/SettingsContainer';
import AccountWidgetContainer from '../AccountWidgetContainer/AccountWidgetContainer';

export default ({hideSettings, showSigninButton}: SettingsAndAccountWidgetProps) => (
   <React.Fragment>
      {!hideSettings && <SettingsContainer/>}
      <AccountWidgetContainer showSigninButton={showSigninButton}/>
   </React.Fragment>
);

interface SettingsAndAccountWidgetProps {
   hideSettings?: boolean;
   showSigninButton?: boolean;
}
